/* accordion */
$(function() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    $('.Accordion').each(function(i, accordion) {
        var accordionTrigger = '.AccordionTrigger';
        var accordionContent = '.AccordionContent';

        var $accordion = $(this);
        var $accordionTrigger = $accordion.find(accordionTrigger);
        var $accordionContent = $accordion.find(accordionContent);

        // Apply ARIA and display values on load
        if ($accordionTrigger.hasClass('__active')) {
            $accordionTrigger.attr('aria-expanded', true);
            $accordionContent.show();
            $accordionContent.attr('aria-hidden', false);
        } else {
            $accordionTrigger.attr('aria-expanded', false);
            $accordionContent.hide();
            $accordionContent.attr('aria-hidden', true);
        }

        // On click of accordion trigger
        $accordionTrigger.on('click', function(e) {
            e.preventDefault();
            var $trigger = $(this);
            var $currentAccordion = $trigger.closest('.Accordion');
            var $currentContent = $currentAccordion.find('.AccordionContent');

            // Close an open accordion
            if ($trigger.hasClass('__active')) {
                $trigger.attr('aria-expanded', false).removeClass('__active');
                $currentContent.attr('aria-hidden', true);
                if (prefersReducedMotion) {
                    $currentContent.hide();
                } else {
                    $currentContent.slideUp();
                }

            // Open a closed accordion
            } else {
                $trigger.attr('aria-expanded', true).addClass('__active');

                $currentContent.attr('aria-hidden', false);

                // Function to check whether we need to scroll
                var scrollAccordionIntoView = function() {
                    var triggerTop = $trigger.offset().top;
                    var triggerBottom = triggerTop + $trigger.outerHeight();

                    var viewportTop = $(window).scrollTop();
                    var viewportBottom = viewportTop + $(window).height();

                    // Only scroll if trigger is outside the viewport
                    if (triggerTop < viewportTop || triggerBottom > viewportBottom) {
                        var scrollPosition = triggerTop - 20;

                        if (prefersReducedMotion) {
                            // Jump immediately
                            $(window).scrollTop(scrollPosition);
                        } else {
                            // Animate scroll
                            $('html, body').animate({
                                scrollTop: scrollPosition
                            }, 300);
                        }
                    }
                };

                if (prefersReducedMotion) {
                    // Show immediately, then check position
                    $currentContent.show();
                    scrollAccordionIntoView();
                } else {
                    // Wait until expansion animation finishes
                    $currentContent.slideDown(function() {
                        scrollAccordionIntoView();
                    });
                }
            }
        });
    });
});